import { render, staticRenderFns } from "./CGUPopup.vue?vue&type=template&id=207c22ac&"
import script from "./CGUPopup.vue?vue&type=script&lang=js&"
export * from "./CGUPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports